'use client';
import { useLocationManagement } from '@hooks/useLocationManagement';
import { EventsCarouselSkeleton } from '@v2/components/EventsCarouselSkeleton/EventsCarouselSkeleton';
import { EventCardDTO } from '@v2/types';
import { useSession } from 'next-auth/react';
import { Suspense, useMemo } from 'react';
import { EventLocationDropdown } from './EventLocationDropdown';
import { EventsCarousel } from './EventsCarousel';

interface Props {
  initialLocationEvents?: EventCardDTO[];
  dropdownPrimaryColor?: string;
  itemListName?: string;
}

export const EventsCarouselByLocation = ({
  initialLocationEvents = [],
  dropdownPrimaryColor,
  itemListName = 'nearby_events',
}: Props) => {
  const serverEvents = useMemo(() => initialLocationEvents, []);
  const { data } = useSession();
  const defaultUserLocation = (data?.user as { location?: string } | undefined)
    ?.location;

  const { locationCityName, selectedLocation, loading, onLocationChange } =
    useLocationManagement({
      defaultUserLocation,
    });

  return (
    <div className="flex flex-col">
      <EventLocationDropdown
        selectedLocation={selectedLocation}
        onLocationChange={onLocationChange}
        primaryColor={dropdownPrimaryColor}
      />

      <Suspense fallback={<EventsCarouselSkeleton withTitle={false} />}>
        <EventsCarousel
          initialEvents={serverEvents}
          location={locationCityName}
          isLocationLoading={loading}
          itemListName={itemListName}
        />
      </Suspense>
    </div>
  );
};
